module.exports = __webpack_public_path__ + "static/img/raas_main_1.0981c77.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/raas_main_1.png
// module id = z7Bm
// module chunks = 0